import Modal from '@Components/Shared/Modals/Modal';
import MultiFactorContent from '@Components/Shared/MultiFactorContent';

const MultiFactorModal = (props) => {
    return (
        <>
            <Modal containerClassName='multifactor-modal' onEscapeKeyClose={() => props.toggleModal()}>
                <Modal.Header onClose={() => props.toggleModal()}>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <MultiFactorContent
                        {...props}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}

export default MultiFactorModal;